import { render, staticRenderFns } from "./TaskStageListAddNew.vue?vue&type=template&id=b2f191dc&"
import script from "./TaskStageListAddNew.vue?vue&type=script&lang=js&"
export * from "./TaskStageListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./TaskStageListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports